import { PLAYER_DATA_SAVEID, LOCATIONS_VISIT_ORDER, LOCATIONS } from '../constants/AppConstants';

export default class PlayerController {
  constructor(data) {
    this.playerLocations = {};
    this.currentLocation = false;
    this.locationStickerQueued = false;
    this.storyIntroSeen = false;
    this.storyOutroSeen = false;
    this.certificateEarned = false;

    this.currentStoryLocation = LOCATIONS_VISIT_ORDER[0];

    this.tutorialsSeen = [];

    this.serialisable = [
      'playerLocations',
      'tutorialsSeen',
      'currentLocation',
      'locationStickerQueued',
      'storyIntroSeen',
      'storyOutroSeen',
      'currentStoryLocation',
      'certificateEarned',
    ];

    if (data) {
      this.deserialize(data);
    }
  }

  clearCurrentState() {
    this.currentLocation = false;
    this.suitcaseLaunchedGame = false;
  }

  getLocationProgress(locationid) {
    if (!this.playerLocations[locationid]) {
      this.playerLocations[locationid] = {
        visited: false,
        unlocked: false,
        video: false,
        videoliked: false,
        souvenir: false,
        poll: false,
        pollsubmitted: false,
        selfie: false,
        foodgame: false,
        chasegame: false,
        sticker: false,
        storyoutro: false,
        selfieliked: false,
        canleave: false,
        canchase: false,
      };
    }

    return this.playerLocations[locationid];
  }

  //-------- STORY CUTSCENES

  setStoryIntroSeen(value) {
    this.storyIntroSeen = value || true;
    this.saveProgress();
  }
  getStoryIntroSeen() {
    return this.storyIntroSeen;
  }
  setStoryOutroSeen(value) {
    this.storyOutroSeen = value || true;
    this.saveProgress();
  }
  getStoryOutroSeen() {
    return this.storyOutroSeen;
  }

  //-------- PLAYER LOCATION

  setCurrentStoryLocation(locationid) {
    this.setPlayerProgress('currentStoryLocation', locationid);
  }

  setNextStoryLocation() {
    let currentIndex = LOCATIONS_VISIT_ORDER.indexOf(this.currentStoryLocation);
    if (currentIndex < LOCATIONS_VISIT_ORDER.length - 1) {
      currentIndex++;
    }
    this.setCurrentStoryLocation(LOCATIONS_VISIT_ORDER[currentIndex]);
  }

  getCurrentStoryLocation() {
    return this.currentStoryLocation;
  }

  setCurrentLocation(locationid) {
    this.currentLocation = locationid;
    this.setPlayerProgress('currentLocation', locationid);
  }

  getCurrentLocation() {
    return this.currentLocation || LOCATIONS_VISIT_ORDER[0];
  }

  //-------- CERTIFICATE
  setCertificateEarned() {
    this.setPlayerProgress('certificateEarned', true);
  }
  getCertificateEarned() {
    return this.certificateEarned;
  }

  //-------- LOCATION OUTRO

  setLocationOutroSeen(locationid) {
    this.setLocationProgress(locationid, 'storyoutro', true);
  }
  getLocationOutroSeen(locationid) {
    return this.getLocationProgress(locationid).storyoutro;
  }

  //-------- LOCATION VISITED

  setLocationVisited(locationid) {
    this.setLocationProgress(locationid, 'visited', true);
  }
  getLocationVisited(locationid) {
    return this.getLocationProgress(locationid).visited;
  }

  //-------- LOCATION SELFIE

  setSelfieSeen(locationid) {
    this.setLocationProgress(locationid, 'selfie', true);
  }
  getSelfieSeen(locationid) {
    return this.getLocationProgress(locationid).selfie;
  }
  setSelfieLiked(locationid) {
    this.setLocationProgress(locationid, 'selfieliked', true);
  }
  getSelfieLiked(locationid) {
    return this.getLocationProgress(locationid).selfieliked;
  }

  //-------- LOCATION VIDEO

  setVideoSeen(locationid) {
    this.setLocationProgress(locationid, 'video', true);
  }
  getVideoSeen(locationid) {
    return this.getLocationProgress(locationid).video;
  }

  setVideoLiked(locationid) {
    this.setLocationProgress(locationid, 'videoliked', true);
  }
  getVideoLiked(locationid) {
    return this.getLocationProgress(locationid).videoliked;
  }

  //-------- LOCATION SOUVENIR

  setSouvenirSeen(locationid) {
    this.setLocationProgress(locationid, 'souvener', true);
  }
  getSouvenirSeen(locationid) {
    return this.getLocationProgress(locationid).souvener;
  }

  //-------- LOCATION POLL

  setPollSeen(locationid) {
    this.setLocationProgress(locationid, 'poll', true);
  }
  getPollSeen(locationid) {
    return this.getLocationProgress(locationid).poll;
  }
  setPollSubmitted(locationid) {
    this.setLocationProgress(locationid, 'pollsubmitted', true);
  }
  getPollSubmitted(locationid) {
    return this.getLocationProgress(locationid).pollsubmitted;
  }

  //-------- LOCATION FOOD GAME

  setFoodGamePlayed(locationid) {
    this.setLocationProgress(locationid, 'foodgame', true);
  }

  getFoodGamePlayed(locationid) {
    return this.getLocationProgress(locationid).foodgame;
  }

  //-------- LOCATION CHASE GAME

  setChaseGamePlayed(locationid) {
    this.setLocationProgress(locationid, 'chasegame', true);
  }
  getChaseGameRequirementsMet(locationid) {
    if (!this.getSelfieSeen(locationid)) {
      return false;
    }
    if (!this.getFoodGamePlayed(locationid)) {
      return false;
    }
    if (!this.getSouvenirSeen(locationid)) {
      return false;
    }
    if (!this.getPollSeen(locationid)) {
      return false;
    }
    if (!this.getVideoSeen(locationid)) {
      return false;
    }
    return true;
  }
  getChaseGamePlayed(locationid) {
    return this.getLocationProgress(locationid).chasegame;
  }
  setCanPlayChaseGame(locationid) {
    this.setLocationProgress(locationid, 'canchase', true);
  }
  getCanPlayChaseGame(locationid) {
    return this.getLocationProgress(locationid).canchase;
  }

  //-------- SET LOCATION PROGRESS

  setLocationProgress(locationid, action, value) {
    this.getLocationProgress(locationid)[action] = value;
    this.saveProgress();
  }

  setPlayerProgress(prop, value) {
    this[prop] = value;
    this.saveProgress();
  }

  getLeaveLocationRequirementsMet(locationid) {
    if (!this.getChaseGamePlayed(locationid)) {
      return false;
    }
    return true;
  }

  setCanLeaveLocation(locationid) {
    this.setLocationProgress(locationid, 'canleave', true);
  }

  getCanLeaveLocation(locationid) {
    return this.getLocationProgress(locationid).canleave;
  }

  //-------- LOCATIONS VISTED

  getCanVisitLocation(locationid) {
    const targetIndex = LOCATIONS_VISIT_ORDER.indexOf(locationid);
    if (targetIndex == 0) {
      return true;
    }
    const previousLocation = LOCATIONS_VISIT_ORDER[targetIndex - 1] || LOCATIONS_VISIT_ORDER[0];
    return this.getLocationVisited(previousLocation);
  }

  getNextLocation() {
    const targetIndex = LOCATIONS_VISIT_ORDER.indexOf(this.currentLocation);
    return LOCATIONS_VISIT_ORDER[targetIndex + 1] || false;
  }

  getVisitedLocations() {
    return LOCATIONS.filter((locationid) => {
      return this.getLocationVisited(locationid);
    });
  }

  //-------- TUTORIALS

  setTutorialSeen(tutorialid) {
    if (!this.tutorialsSeen.includes(tutorialid)) {
      this.tutorialsSeen.push(tutorialid);
      this.saveProgress();
    }
  }

  getTutorialSeen(tutorialid) {
    return this.tutorialsSeen.includes(tutorialid);
  }

  //-------- STICKERS

  queueLocationSticker(locationid) {
    if (!this.hasLocationSticker()) {
      this.locationStickerQueued = locationid;
    }
  }

  getQueuedLocationSticker() {
    return this.locationStickerQueued;
  }

  earnLocationSticker(locationid) {
    if (this.locationStickerQueued == locationid) {
      this.locationStickerQueued = false;
    }
    this.setLocationProgress(locationid, 'sticker', true);
  }

  hasLocationSticker(locationid) {
    return this.getLocationProgress(locationid).sticker;
  }

  getStickersEarned() {
    return LOCATIONS.filter((locationid) => {
      return this.hasLocationSticker(locationid);
    });
  }
  //-------- SAVE / LOAD / DESERIALIZE

  saveProgress() {
    const data = {};
    this.serialisable.forEach((key) => {
      data[key] = this[key];
    });
    localStorage.setItem(PLAYER_DATA_SAVEID, JSON.stringify(data));
  }

  loadSavedData() {
    const savedData = localStorage.getItem(PLAYER_DATA_SAVEID);
    if (savedData) {
      this.deserialize(JSON.parse(savedData));
    }
  }

  deserialize(data) {
    this.serialisable.forEach((key) => {
      if (data[key]) {
        this[key] = data[key];
      }
    });
  }
}



// WEBPACK FOOTER //
// ./js/app/controller/PlayerController.js